export default "__VITE_ASSET__i90aJUqW__"